module.exports = __webpack_public_path__ + "static/media/autism-assistance-for-all.e47449b5.jpg";